export function hasProperty(crmObject, propertyName) {
  return Boolean(crmObject.properties && propertyName in crmObject.properties);
}

/**
 * Returns the value of @propertyName in @crmObject.
 *
 * If @propertyName is not present:
 *   - returns undefined when @defaultValue is not provided.
 *   - returns @defaultValue otherwise.
 * @param crmObject The CRM object
 * @param propertyName The property name
 * @param defaultValue Optional default value if @propertyName is not found in @crmObject
 */
export function getPropertyValue(crmObject, propertyName, defaultValue) {
  if (hasProperty(crmObject, propertyName)) {
    return crmObject.properties[propertyName].value;
  }
  return defaultValue;
}